import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-union",
  templateUrl: "./med-icon-union.component.html",
})
export class MedIconUnionComponent extends SvgMixinComponent {}
